<template>
	<div class="form__field" :class="`--${size}`">
		<label :for="name" class="label">
			<span>{{ label }}</span>
			<span v-if="required" class="required-symbol">*</span>
		</label>
		<input v-if="type !== 'textarea'" :type="type" :id="name" :name="name" @input.passive="input" @focusout="input"
			@keydown.enter.prevent="" :value="modelValue.value" :placeholder="placeholder" :maxlength="counter" />
		<textarea v-if="type === 'textarea'" :id="name" :name="name" @input.passive="input" @focusout="input"
			@keydown.enter.prevent="" :value="modelValue.value" :placeholder="placeholder" :maxlength="counter" />

		<span class="character-counter" v-if="counter !== 12000">{{ modelValue.value.length }}/{{ counter }}</span>
		<p v-if="message" class="note">
			{{ $t(`form.messages.${name}`) }}
		</p>
		<p :class="['input-error', { '--hidden': !(!modelValue.valid && onFocus) }]">
			{{ $t(`form.errors.${name}`) }}
		</p>
	</div>
</template>

<script>
import { resetTime } from '@/helpers/index.js'
import { REGEX } from '@/helpers/regex.js'

export default {
	name: 'FormInput',
	props: {
		label: {
			type: String,
			required: true
		},
		modelValue: {
			type: Object,
			required: true
		},
		size: {
			type: String,
			default: null
		},
		name: {
			type: String,
			required: true
		},
		message: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text',
			validator: value => ['email', 'text', 'textarea', 'number', 'tel', 'url', 'date'].includes(value)
		},
		required: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: null
		},
		counter: {
			type: Number,
			default: 12000
		},
		minDate: {
			type: String,
			default: null
		},
		maxDate: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			onFocus: false
		}
	},
	methods: {
		input(event) {
			this.onFocus = true

			this.$emit('update:modelValue', {
				value: event.target.value,
				valid: this.validate(event.target.value)
			})
		},
		validate(value) {
			if (!this.required && !value) {
				return true
			}

			switch (this.name) {
				case 'employee_name':
					return REGEX.NAME.test(value)
				case 'url':
					return REGEX.URL.test(value)
				case 'loginEmail':
					return REGEX.ODQEMAIL.test(value)
				case 'start_date': {
					if (value) {
						if (!this.maxDate) return true
						
						const threshold = 10000

						const valueTime = resetTime(value).getTime()

						const endTime = resetTime(this.maxDate)
						return valueTime - threshold <= endTime
					}
					return false
				}
				case 'end_date': {
					if (value) {
						if (!this.minDate) return true
						
						const threshold = 10000

						const valueTime = resetTime(value).getTime()
						
						const startTime = resetTime(this.minDate).getTime()
						return valueTime + threshold >= startTime
					}
					return false
				}
				default: {
					if (!value) return false
					return REGEX.TEXT_SYMBOLS.test(value)

				}
			}
		}
	},
	emits: ['update:modelValue'],
	mounted() {
		this.$emit('update:modelValue', {
			value: this.modelValue.value,
			valid: this.validate(this.modelValue.value)
		})
	}
}
</script>